import React, {useState} from "react";
import  "./ContactUs.css";
import Form from "./Form";
import ContactUsIcons from "./ContactUsIcons";
import ContactUsDetails from "./ContactUsDetails";


const ContactUs = React.memo(props => {
    let engContactUsForm = props.lang==='en';
    let mailTo = props.mailTo;
    return (
    <React.Fragment>
        <div className={engContactUsForm?"containerContactFormEN":"containerContactForm"}>
            <div className="extraContainer">
            {engContactUsForm?
                <div className="container">
                        <div className="contactUs40EN">
                            <h3 className="contactUsEng">Keep in touch</h3>
                            {props.items[0] && 
                            <ContactUsIcons items={props.items[0]} lang={props.lang}/>
                            }
                        </div>
                        <div className="contactUs60EN">
                        <h3 className="contactUsEng">Send a message</h3>
                            <Form siteUrl={props.siteUrl} mailTo={mailTo} lang={props.lang} museumsDropDown={props.museumsDropDown} />
                        </div>
            </div>
            :
                <div className="container">
                    <div className="contactUs60">
                    <h3>שלחו הודעה</h3>
                        <Form siteUrl={props.siteUrl} mailTo={mailTo} lang={props.lang} museumsDropDown={props.museumsDropDown} />
                    </div>
                    <div className="contactUs40">
                        <h3>שמרו על קשר</h3>
                        {props.items[0] && 
                        <ContactUsIcons items={props.items[0]} lang={props.lang}/>
                        }
                    </div>
            </div>
            }
            </div>
            {props.unitOrSites &&<div className="contactUsDetailsContainer">
                <div className="container">
                    <ContactUsDetails items={props.items[0]} lang={props.lang} />
                </div>
            </div>}
        </div>
    </React.Fragment>
    );
});
export default ContactUs;                        
